import { BzDateFns, IsoDateString } from '../../../common'
import { AccountGuid } from '../../Accounts/Account'
import { CompanyGuid } from '../../Company/Company'
import { Guid } from '../../common-schemas'
import { ContactGuid } from '../../contacts/Contact'
import { JobGuid } from '../../Job'
import { LoanRecord, LoanRecordStatus, LoanStatus } from './Lending'

export type FetchLoanRecordStatus = {
  loanStatus: LoanStatus
  loanStatusDetail?: string
  occurredAt?: IsoDateString
  createdAt?: IsoDateString
}

export type FetchLoanRecord = {
  wisetackLoanRecordGuid: Guid
  companyGuid: CompanyGuid
  accountGuid: AccountGuid
  invoiceGuid: Guid
  contactGuid: ContactGuid
  jobGuid?: JobGuid
  wisetackMerchantGuid: Guid
  wisetackTransactionGuid: Guid
  requestedLoanAmountUsc: number
  approvedLoanAmountUsc?: number
  settledLoanAmountUsc?: number
  processingFeeUsc?: number
  loanApplicationLink: string
  createdAt?: IsoDateString
  updatedAt?: IsoDateString
  expiresAt?: IsoDateString
  wisetackLoanStatuses: FetchLoanRecordStatus[]
  contact: {
    fullName?: string
  }
}

export const convertFetchLoanRecordStatusToLoanRecordStatus = (input: FetchLoanRecordStatus): LoanRecordStatus => ({
  loanStatus: input.loanStatus,
  loanStatusDetail: input.loanStatusDetail,
  occurredAt: input.occurredAt ?? BzDateFns.nowISOString(),
  createdAt: input.createdAt ?? BzDateFns.nowISOString(),
})

export const convertFetchLoanRecordToLoanRecord = (input: FetchLoanRecord): LoanRecord => {
  const loanRecordStatuses = input.wisetackLoanStatuses.map(convertFetchLoanRecordStatusToLoanRecordStatus)
  const latestLoanRecordStatus = [...loanRecordStatuses].sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0]

  return {
    loanRecordGuid: input.wisetackLoanRecordGuid,
    companyGuid: input.companyGuid,
    accountGuid: input.accountGuid,
    invoiceGuid: input.invoiceGuid,
    contactGuid: input.contactGuid,
    jobGuid: input.jobGuid,
    merchantGuid: input.wisetackMerchantGuid,
    externalTransactionGuid: input.wisetackTransactionGuid,
    requestedLoanAmountUsc: input.requestedLoanAmountUsc,
    approvedLoanAmountUsc: input.approvedLoanAmountUsc,
    settledLoanAmountUsc: input.settledLoanAmountUsc,
    processingFeeUsc: input.processingFeeUsc,
    loanApplicationLink: input.loanApplicationLink,
    createdAt: input.createdAt ?? BzDateFns.nowISOString(),
    updatedAt: input.updatedAt ?? BzDateFns.nowISOString(),
    expiresAt: input.expiresAt,
    loanRecordStatuses,
    latestLoanRecordStatus,
    contactName: input.contact.fullName ?? '',
  }
}
